export default __webpack_public_path__ + "static/media/clinic10.bb484d0c.jpg";